var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.5,
    height: 846,
    viewBox: "0 0 73.5 846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-712.5 -6191.89)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 73,
    transform: "translate(713 6192.39)",
    fill: "none",
    stroke: "#9ba037",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 73,
    transform: "translate(713 6316.39)",
    fill: "none",
    stroke: "#9ba037",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 73,
    transform: "translate(713 6466.39)",
    fill: "none",
    stroke: "#9ba037",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 73,
    transform: "translate(713 6584.39)",
    fill: "none",
    stroke: "#9ba037",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 73,
    transform: "translate(713 6734.39)",
    fill: "none",
    stroke: "#9ba037",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 73,
    transform: "translate(713 6884.39)",
    fill: "none",
    stroke: "#9ba037",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x2: 73,
    transform: "translate(713 7037.39)",
    fill: "none",
    stroke: "#9ba037",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    y2: 845.11,
    transform: "translate(713 6192.39)",
    fill: "none",
    stroke: "#9ba037",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.999d3342bc6f1261ebed51a064c1f967.svg";
export { ForwardRef as ReactComponent };